import { useEffect, useRef, useState } from 'react';
import { REACT_APP_API_BASE } from '../../../config';

const useClassifications = (scenarioId, fetchFn) => {
    const [state, setState] = useState({ data: [], isLoading: true });
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (!fetchFn) return;
        
        setState(prev => ({ ...prev, isLoading: true }));

        const loadClassifications = async () => {
            try {
                const res = await fetchFn(`${REACT_APP_API_BASE}/salesdistrict/classification/${scenarioId ? `/${scenarioId}` : ''}`);
                const payload = await res.json();
                
                if (isMountedRef.current) {
                    setState({
                        data: Array.isArray(payload) ? payload : [],
                        isLoading: false
                    });
                }
            } catch (error) {
                console.error('Failed to load classifications', error);
                if (isMountedRef.current) {
                    setState({
                        data: [],
                        isLoading: false
                    });
                }
            }
        };

        loadClassifications();
    }, [scenarioId]); // Bara scenarioId som dependency - fetchFn används direkt utan att vara i dependencies
    
    const reload = async () => {
        if (!fetchFn) return;
        
        setState(prev => ({ ...prev, isLoading: true }));
        
        try {
            const res = await fetchFn(`${REACT_APP_API_BASE}/salesdistrict/classification/${scenarioId ? `/${scenarioId}` : ''}`);
            const payload = await res.json();
            
            if (isMountedRef.current) {
                setState({
                    data: Array.isArray(payload) ? payload : [],
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Failed to load classifications', error);
            if (isMountedRef.current) {
                setState({
                    data: [],
                    isLoading: false
                });
            }
        }
    };
    
    return {
        ...state,
        reload
    };
};

export default useClassifications;

